/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_ChecksumsInputs */

const en_wc_dl_checksums = /** @type {(inputs: Wc_Dl_ChecksumsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download SHA256SUMS.txt`)
};

/**
* | output |
* | --- |
* | "Download SHA256SUMS.txt" |
*
* @param {Wc_Dl_ChecksumsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_checksums = /** @type {((inputs?: Wc_Dl_ChecksumsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_ChecksumsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_checksums(inputs)
});
export { wc_dl_checksums as "wc.dl.checksums" }